var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRigth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21599 15.5603C0.934407 15.2783 0.776245 14.8961 0.776245 14.4977C0.776245 14.0992 0.934407 13.717 1.21599 13.4351L6.66919 7.98191L1.21599 2.52871C0.950386 2.24367 0.805791 1.86666 0.812664 1.47712C0.819537 1.08757 0.977342 0.7159 1.25284 0.440408C1.52833 0.164914 1.9 0.00710679 2.28954 0.000233659C2.67909 -0.00663947 3.05609 0.137959 3.34113 0.403562L9.85691 6.91934C10.1385 7.20127 10.2967 7.58344 10.2967 7.98191C10.2967 8.38037 10.1385 8.76255 9.85691 9.04448L3.34113 15.5603C3.0592 15.8418 2.67703 16 2.27856 16C1.8801 16 1.49792 15.8418 1.21599 15.5603Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRigth);
export default __webpack_public_path__ + "static/media/icon--arrow-rigth.c39cb0cfa21b706b72f70b903fd6e377.svg";
export { ForwardRef as ReactComponent };